<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Edit mixing</span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="editMixinState" @submit.prevent="saveMixin">
          <v-container fluid grid-list-xl class="pt-0">
            <v-layout wrap align-top justify-end>
              <v-btn color="warning" flat @click="close">
                Close
              </v-btn>
              <v-btn type="submit" color="success">
                Save
              </v-btn>
            </v-layout>
          </v-container>
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>
              <v-flex xs12>
                <validate>
                  <v-text-field
                    v-model="data.mixin.name"
                    required
                    label="Name"
                    name="name"
                    maxlength="40"
                    hide-details
                    counter
                    clearable
                  >
                  </v-text-field>
                  <field-messages
                    name="name"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Name is a required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
              <v-flex xs12>
                <async-autocomplete
                  v-model="data.mixin.white_masses"
                  :items="mixRecipes"
                  name="white_masses"
                  label="Select white masses"
                  item-text="name"
                  item-value="id"
                  return-object
                  multiple
                />
              </v-flex>
              <v-flex xs12>
                <async-autocomplete
                  v-model="data.mixin.premixes"
                  :items="premixes"
                  name="premixes"
                  label="Select premixes"
                  item-text="name"
                  item-value="id"
                  return-object
                  multiple
                />
              </v-flex>
              <v-flex xs12>
                <validate>
                  <async-autocomplete
                    v-model="data.mixin.ingredients"
                    :items="ingredients"
                    name="ingredients"
                    label="Select ingredients"
                    item-text="name"
                    item-value="id"
                    return-object
                    multiple
                  />
                  <field-messages
                    name="ingredients"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Ingredients is a
                      required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
              <v-flex sx12>
                <multiple-inputs
                  v-model="custom_ingredients"
                  :items="customIngredients"
                  name="customIngredients"
                  label="Add custom ingredients"
                  item-text="name"
                  item-value="name"
                  :returnObject="true"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Mixins from '@/orm/models/Mixins';
import MixRecipes from '@/orm/models/MixRecipes';
import Premixes from '@/orm/models/Premixes';
import CustomIngredients from '@/orm/models/CustomIngredients';
import asyncAutocomplete from '@/components/form/asyncAutocomplete';
import multipleInputs from '@/components/form/multipleInputs';

export default {
  name: 'editMixinPopup',
  props: {
    dialog: Boolean,
    ingredientsGroups: Array,
    mixin: {
      type: Object,
      default: () => new Mixins(),
    },
  },
  data() {
    return {
      data: {
        mixin: {},
      },
      custom_ingredients: [],
      editMixinState: {},
    };
  },
  watch: {
    'mixin': {
      immediate: true,
      handler: function(mixin) {
        this.data.mixin = JSON.parse(JSON.stringify(mixin));
        this.custom_ingredients = JSON.parse(JSON.stringify(mixin.custom_ingredients));
      },
    },
  },
  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
    categories() {
      return this.ingredientsGroups
        .reduce((acc, group) => {
          const categories = group.categories.map(category => {
            category.groupId = group.id;
            return category;
          });
          acc = [
            ...acc,
            ...JSON.parse(JSON.stringify(categories)),
          ];
          return acc;
        }, []);
    },
    ingredients() {
      return this.categories
        .reduce((acc, cat) => {
          const ingredients = cat.ingredients.map(ingredient => {
            ingredient.groupId = cat.groupId;
            ingredient.categoryId = cat.id;
            ingredient.target = 0;
            ingredient.result = 0;
            return ingredient;
          });
          acc = [
            ...acc,
            ...JSON.parse(JSON.stringify(ingredients)),
          ];
          return acc;
        }, []);
    },
    mixRecipes() {
      const mixRecipes = MixRecipes.all();
      return JSON.parse(JSON.stringify(mixRecipes)).map(recipe => {
        recipe.target = 0;
        recipe.result = 0;
        return recipe;
      });
    },
    premixes() {
      const premixes = Premixes.all();
      return JSON.parse(JSON.stringify(premixes)).map(premix => {
        premix.target = premix.target || 0;
        premix.result = 0;
        return premix;
      });
    },
    customIngredients() {
      return CustomIngredients.all();
    },
  },
  methods: {
    close() {
      this.data.mixin = new Mixins();
      this.custom_ingredients = [];
      this.editMixinState._reset();
      this.dialogLocal = false;
    },
    saveMixin() {
      if (!this.editMixinState.$valid) {
        return;
      }
      this.data.mixin.custom_ingredients = this.custom_ingredients.map(ci => {
        if (typeof ci === 'object') return ci;
        return new CustomIngredients({ name: ci }).$toJson();
      });
      this.$emit('saveMixin', this.data);
      this.close();
    },
  },
  components: {
    asyncAutocomplete,
    multipleInputs,
  },
};
</script>
